import { useMutation } from "@apollo/client/react";
import SharedCreateProduct from "@repo/components/src/shared/product/create";
import type { CreateProductResult } from "@repo/components/src/shared/product/create/types";
import { Box } from "@repo/components/src/ui/box";
import { Spinner } from "@repo/components/src/ui/spinner";
import { CurrencyCode } from "@repo/components/src/utils/money/currencies";
import { CreateProductMutationVariables } from "@repo/graphql/documents/product/mutation.generated";
import React from "react";

type Props = {
  brandId: string;
  currency: CurrencyCode | null;
  mutationOptions: useMutation.Options<
    CreateProductResult,
    CreateProductMutationVariables
  >;
};

/**
 * The campaign wizard's "Crear producto" modal.
 *
 * The form itself now lives in `@repo/components` so the agent chat's product
 * picker can open the exact same one. It is rendered by the global
 * ModalProvider, outside the brand layout, so the caller passes the brand
 * values in.
 */
const CreateProduct = React.memo((props: Props) => {
  const { brandId, currency, mutationOptions } = props;
  if (!currency) {
    return (
      <Box className="items-center justify-center p-8">
        <Spinner />
      </Box>
    );
  }
  return (
    <SharedCreateProduct
      brandId={brandId}
      currency={currency}
      mutationOptions={mutationOptions}
    />
  );
});

CreateProduct.displayName = "CreateProduct";

export default CreateProduct;
